import { Typography } from '@material-ui/core';
import type { ReactNode } from 'react';
import { useCockpitStyles } from './cockpitStyles';

export interface CockpitSectionHeadProps {
  /** Referenced by the section's `aria-labelledby`. */
  id: string;
  title: string;
  /** One line saying what the section answers. */
  children: ReactNode;
}

/**
 * Every section opens the same way — title, one line of lede, one rule — so the
 * page reads as a sequence of siblings rather than a stack of unrelated panels.
 */
export const CockpitSectionHead = ({
  id,
  title,
  children,
}: CockpitSectionHeadProps) => {
  const classes = useCockpitStyles();
  return (
    <div className={classes.sectionHead}>
      <Typography id={id} component="h2" className={classes.sectionTitle}>
        {title}
      </Typography>
      <Typography variant="body2" className={classes.sectionLede}>
        {children}
      </Typography>
    </div>
  );
};
